import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Salivadna= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={2} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
             Hero headline
                <br />
                <Typography component="span" variant="inherit" color="primary">
                GeneFiX™ Saliva DNA 
                </Typography>
              </span>
            }
            subtitle= " GeneFiX™ is an easy to use DNA saliva collection device that stabilizes DNA long term in 2ml and now the latest 1ml saliva sample options. The collector is pre-filled and has a simple screw-on funnel for simple saliva delivery directly into the non-toxic stabilization buffer. The saliva collection tube clearly indicates the volume of saliva required after which the funnel is removed and cap replaced. Various tube options are now available for both manual and HT or Automated Rackable formats. The unique patented*¹ funnel design prevents flow back and can also be used with our assisted option using foam swabs to collect saliva from babies, elderly or any donor unable to use the funnel. The device is fully specified for sample transport and storage."
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
            Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
           Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/isohleix/isoheli1_O6zK1-YLp4.png?updatedAt=1627468699073"
            alt="genefix"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
Salivadna.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Salivadna;
